// extracted by mini-css-extract-plugin
export default {"backdrop":"LazyLoader_backdrop__cuD+7","logo":"LazyLoader_logo__VJIas","blink":"LazyLoader_blink__GTFqR"};